"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceCodeReader = void 0;
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const multimatch_1 = __importDefault(require("multimatch"));
const JavaScriptObfuscatorCLI_1 = require("../JavaScriptObfuscatorCLI");
class SourceCodeReader {
    constructor(inputPath, options) {
        this.inputPath = inputPath;
        this.options = options;
    }
    static isExcludedPath(filePath, excludePatterns = []) {
        if (!excludePatterns.length) {
            return false;
        }
        const fileName = path.basename(filePath);
        const isExcludedFilePathByGlobPattern = !!multimatch_1.default([filePath], excludePatterns).length;
        const isExcludedFilePathByInclusion = excludePatterns.some((excludePattern) => filePath.includes(excludePattern) || fileName.includes(excludePattern));
        return isExcludedFilePathByInclusion || isExcludedFilePathByGlobPattern;
    }
    static isDirectoryPath(filePath) {
        try {
            return fs.statSync(filePath).isDirectory();
        }
        catch (_a) {
            return false;
        }
    }
    static isFilePath(filePath) {
        try {
            return fs.statSync(filePath).isFile();
        }
        catch (_a) {
            return false;
        }
    }
    static isValidDirectory(directoryPath, excludePatterns = []) {
        return !SourceCodeReader.isExcludedPath(directoryPath, excludePatterns);
    }
    static isValidFile(filePath, excludePatterns = []) {
        return JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.availableInputExtensions.includes(path.extname(filePath))
            && !filePath.includes(JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.obfuscatedFilePrefix)
            && !SourceCodeReader.isExcludedPath(filePath, excludePatterns);
    }
    static readFile(filePath) {
        return {
            filePath: path.normalize(filePath),
            content: fs.readFileSync(filePath, JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.encoding)
        };
    }
    readSourceCode() {
        if (SourceCodeReader.isFilePath(this.inputPath)
            && SourceCodeReader.isValidFile(this.inputPath, this.options.exclude)) {
            return [SourceCodeReader.readFile(this.inputPath)];
        }
        if (SourceCodeReader.isDirectoryPath(this.inputPath)
            && SourceCodeReader.isValidDirectory(this.inputPath, this.options.exclude)) {
            return this.readDirectoryRecursive(this.inputPath);
        }
        const availableFilePaths = JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI
            .availableInputExtensions
            .map((extension) => `\`${extension}\``)
            .join(', ');
        throw new ReferenceError(`Given input path must be a valid ${availableFilePaths} file or directory path`);
    }
    readDirectoryRecursive(directoryPath, filesData = []) {
        fs.readdirSync(directoryPath, JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.encoding)
            .forEach((fileName) => {
            const filePath = `${directoryPath}/${fileName}`;
            if (SourceCodeReader.isDirectoryPath(filePath)
                && SourceCodeReader.isValidDirectory(filePath, this.options.exclude)) {
                filesData.push(...this.readDirectoryRecursive(filePath));
                return;
            }
            if (SourceCodeReader.isFilePath(filePath)
                && SourceCodeReader.isValidFile(filePath, this.options.exclude)) {
                const fileData = SourceCodeReader.readFile(filePath);
                filesData.push(fileData);
                return;
            }
        });
        return filesData;
    }
}
exports.SourceCodeReader = SourceCodeReader;
